import React from 'react';
import { MapPin } from 'lucide-react';
import ComingSoonPage from '../components/ComingSoonPage';

export default function SiteVisitsPage() {
  return (
    <ComingSoonPage
      testId="site-visits-page"
      title="Site Visits"
      arabicTitle="الزيارات الميدانية"
      icon={MapPin}
      accent="#86EFAC"
      description="جدولة الزيارات الميدانية للمدارس، تتبّع نتائج الزيارة، ومزامنة النتائج مع سجلات الصيانة."
    />
  );
}
